import { ChangeDetectorRef, Component, DestroyRef, ElementRef, inject, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import {
  FormGroup,
  FormBuilder,
  Validators,
  FormArray,
  AbstractControl,
} from '@angular/forms';
import { Router } from '@angular/router';
import { MapsComponent } from '../maps/maps.component';
import { catchError, combineLatest, of } from 'rxjs';
import {
  Invalid_IMAGE_FORMAT,
  MSG_CREATE_PARKING,
  MSG_DELETE_VEHICLE,
  USER_ROLES,
} from '@shared/constant/shared.constant';
import { ParkingService } from '../services/parking.service';
import { VehicleTypeDetail } from '@core/models/vehicle-type-detail.model';
import { FacilityDetail } from '@core/models/facility-detail.model';
import { ConfirmationService, MenuItem, SelectItemGroup } from 'primeng/api';
import { CreateComingSoonParking } from '@core/models/create-parking-request.model';
import { HttpErrorResponse } from '@angular/common/http';
import { SuccessModalComponent } from '../success-modal/success-modal.component';
import { ToastService } from '@shared/services/toast.service';
import { DialogControlService } from '@shared/services/dialog-control.service';
import { validateInput, CustomValidator } from '@shared/services/custom-validatior.abstract';
import { BreadcrumbItem, CompanyService } from '@shared/services/company.service';
import { CustomRatesPopupComponent } from '../custom-rates-popup/custom-rates-popup.component';
import { CommonMenuService } from '@shared/services/common-util.service';
import { Editor } from 'primeng/editor';
import { CommonFunctions } from '@shared/common-functions';
import { autoUnsubWith } from '@shared/services/utility.abstract';
import { EncryptionStorageService } from '@core/services/encryption-storage.service';
interface City {
  name: string;
  code: string;
}
interface SpecialRate {
  spotTypeId: string;
  code: string;
  monthlyRate: string;
  dailyRate: string;
  description: string;
}
declare const google: any;

@Component({
  selector: 'app-create-parking',
  templateUrl: './create-parking.component.html',
  styleUrls: ['./create-parking.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class CreateParkingComponent implements OnInit {
  readonly destroyRef = inject(DestroyRef);
  spotTypes = [];
  specialRates: SpecialRate[] = [];
  activeItem: any;
  selectedCities!: City[];
  formData: FormData = new FormData();
  truckTypes: VehicleTypeDetail[] = [];
  parkingLotFacility: any[] = [];
  selectedOptions: any[] = [];
  noOptionsAvailable: boolean = false;
  allowedExtensions = ['jpg', 'jpeg', 'png'];
  fieldsToAdd: string[] = ['hourly', 'weekly']; // Example, add other fields as needed
  count: number = 1;
  buttonDisabled: boolean = true;
  dynamicFormValues: any[] = [];
  facilities: any[] = [];
  facilityName: any[] = [];
  facilitiesList: FacilityDetail[] = [];
  facilityId: { [key: string]: string } = {};
  selectedTruckType: any;
  parkingForm!: FormGroup;
  parkingUpcomingForm!: FormGroup;
  fieldName: string = '';
  items: MenuItem[];
  actions: MenuItem[];
  isImgError1: boolean = false;
  isImgError2: boolean = false;
  isImgError3: boolean = false;
  images: any[] = [];
  imageUrl2: string = '';
  imageUrl3: string = '';
  imageUrl1: string = '';
  btn1: boolean = false;
  btn2: boolean = false;
  btn3: boolean = false;
  totalTruckCategory = 0;
  imagePreview: boolean = false;
  imageLinkForPreview: string;
  visible: boolean = false;
  disableForm: boolean = false;
  optionalValidation: boolean = false;
  comingSoonForm: boolean = false;
  roleName: string;
  companyId: string;
  groupedVehicles: SelectItemGroup[];
  userRoles = USER_ROLES;
  uploadedFile: string  | null = null;
  documentUrl: string = '';
  textLength: { [key: string]: number } = {} 
  maxLength = 999;
  isFileUploaded: boolean = false;
  oneTimeEditorSpaceError: boolean = false;
  oneTimeEditorTextLimitError: boolean = false;
  recurringEditorSpaceError: boolean = false;
  recurringEditorTextLimitError: boolean = false;
  EquipmentMessage: any = `<div class="half-length"><p><b>Half-Length Spot (12x40 ft):</b> This category is designed for smaller trucks, vans, and trailers that require less space. Typically, these spots accommodate vehicles that are up to 40 feet in length. These spots are most suitable for compact or medium-sized trucks that don’t need the extended space of a full-length spot.</p></div>
<div class="half-length full-length"><p><b>Full-Length Spot (12x75 ft):</b> This category is designed for larger trucks and trailers, providing ample space for vehicles that are up to 75 feet long. These spots provide the necessary room for heavy-duty vehicles that require more space for parking, loading, or unloading.</p></div>`
  ckEditorConfig: any = {
    toolbar: [
      [
        'Format',
        'Templates',
        'Bold',
        'Italic',
        'Underline',
        '-',
        'CopyFormatting',
        'RemoveFormat',
        'NumberedList',
        'BulletedList',
      ],
    ],
  };
  @ViewChild('fileUpload') fileUpload: any;
  @ViewChild('fileUpload1') fileUpload1: any;
  @ViewChild('fileUpload2') fileUpload2: any;
  @ViewChild('fileInput') fileInput!: ElementRef;
  termsAndConditionFilePath: string;
  editorTools = {
    toolbar: [
      ['bold', 'italic', 'underline'],
      [{ 'list': 'ordered'}, { 'list': 'bullet' }],
      [{ 'align': [] }],
      ['link'], // removed 'image', 'video', etc.
      ['clean'] // clear formatting
    ]
  };

  constructor(
    private readonly router: Router,
    private readonly dialogControlService: DialogControlService,
    private readonly parkingService: ParkingService,
    private readonly fb: FormBuilder,
    private readonly confirmationService: ConfirmationService,
    private readonly toastService: ToastService,
    private readonly companyService: CompanyService,
    private readonly cdr: ChangeDetectorRef,
    private readonly commonMenuService: CommonMenuService,
    private readonly encryptStorage: EncryptionStorageService
  ) { }
  ngOnInit(): void {
    this.roleName = this.encryptStorage.getItem('roleName');
    this.companyId = this.encryptStorage.getItem('companyId');
    const rolePath = this.roleName === USER_ROLES.SUPER_ADMIN ? 'super-admin' : 'manager';
    const breadcrumbObj: BreadcrumbItem[] = [
      {
        title: 'Parking Locations',
        url: `${rolePath}/parking-list/${this.companyId}`
      },
      {
        title: 'Create Parking'
      }
    ];
    this.companyService.setAdminHeaders('0', breadcrumbObj);
    
    this.buildForm();
    this.bindAllMasterData();
  }

  updateRecurringInstructionsValidator() {
    const recurringInstructionsControl = this.parkingForm.get('recurringBookingsInstruction');
    if (this.isFileUploaded) {
      // If a file is uploaded, remove the required validator
      recurringInstructionsControl?.clearValidators();
    } else {
      // If no file is uploaded, set the required validator
      recurringInstructionsControl?.setValidators([Validators.required]);
    }
    recurringInstructionsControl?.updateValueAndValidity(); // Update the control's validity
  }

  bindAllMasterData(): void {
    
    combineLatest([
      this.parkingService.getVehicleTypeList().pipe(
        catchError(() => {
          return of(null);
        })
      ),
      this.parkingService.getFacilityList().pipe(
        catchError(() => {
          return of(null);
        })
      ),
    ])
      .pipe(
        autoUnsubWith(this.destroyRef))
      .subscribe({
        next: ([_vehicleData, _facilityData]: [
          VehicleTypeDetail[],
          FacilityDetail[]
        ]) => {
          if (_vehicleData) {
            this.spotTypes = _vehicleData;
            _vehicleData.forEach(vehicle => {
              const truckType = this.newTruckType(vehicle.id, vehicle.name);
              this.truckTypeArray.push(truckType);
            });
          }

          if (_facilityData) {
            this.facilitiesList = _facilityData;
          }
        },
      });
  }
  buildForm(): void {
    this.parkingForm = this.fb.group({
      name: ['', [Validators.required]],
      hazardousLoadRate: [0, [CustomValidator.validateLessThanHundred]],
      location: [''],
      offer: [0, [CustomValidator.validateLessThanHundred]],
      taxAndFees: ['', [CustomValidator.validateLessThanHundred]],
      truckTypeArray: this.fb.array([]),
      parkingLotFacility: this.fb.array([]),
      oneTimeBookingsInstruction : ['', [Validators.required]],
      recurringBookingsInstruction : ['', [Validators.required]],
      parkingPhotos: [''],
      locAddress: ['', Validators.required],
      specialRates : [this.specialRates],
      oneTimeAccessCode: ['', [Validators.minLength(2)]],
      monthlyTimeAccessCode: ['', [Validators.minLength(2)]],
      termsAndConditionFilePath: ['']
    });
    this.parkingForm
      .get('locAddress')
      .valueChanges.subscribe((location: string) => {
        if (!location) {
          this.parkingForm.patchValue({ location: '' });
        }
      });

    this.parkingUpcomingForm = this.fb.group({
      parkingName: ['', [Validators.required]],
      location: [''],
      parkingLocation: ['', Validators.required],
    });
    this.parkingUpcomingForm
      .get('parkingLocation')
      .valueChanges.subscribe((location: string) => {
        if (!location) {
          this.parkingUpcomingForm.patchValue({ location: '' });
        }
      });
  }
  newTruckType(vehicleTypeId: string, vehicleName: string): FormGroup {
    return this.fb.group({
      spotTypeId: [vehicleTypeId],
      spotType: [vehicleName],
      dailyRate: ['', [Validators.required,CustomValidator.validateGreaterThanZero]],
      monthlyRate: ['',  [Validators.required,CustomValidator.validateGreaterThanZero]],
    });
  }
  get truckTypeArray(): FormArray {
    return this.parkingForm.get('truckTypeArray') as FormArray;
  }
  isFieldInvalid(fieldName: string) {
    const control = this.parkingForm.get(fieldName);
    return control?.invalid && (control?.touched || control?.dirty);
  }

  generateUniqueNumber(): string {
    return 'UN' + Date.now().toString();
  }

  oneTimeLimitText(_event: any, editor: Editor, dataKey: string) {
    const quill = editor.getQuill(); // Get Quill editor instance
    const content = quill.getText(); // Get plain text (ignoring HTML tags)
    const contents = quill.getContents();
    const ops = contents.ops;

    let index = 0;

    ops.forEach(op => {
      if (op.insert && op.insert.image) {
        quill.deleteText(index, 1); // delete image
      } else if (typeof op.insert === 'string') {
        index += op.insert.length; // count text length to keep index updated
      } else {
        index += 1; // account for other inserts
      }
    });
    this.oneTimeEditorTextLimitError = false;
    this.oneTimeEditorSpaceError = false;

    if( content.length > 1) {
      const trimContent = content.trim();
      if (trimContent.length === 0) {
        this.oneTimeEditorSpaceError = true; // Content is empty or only spaces
        this.textLength[dataKey] = content.length - 1; // Prevent negative value
        this.parkingForm.get('oneTimeBookingsInstructions')?.setErrors({ required: true }); // Set 'required' error
      } 
      // Check if the content exceeds 1000 characters
      else if (content.length > 1001) {
        this.oneTimeEditorTextLimitError = true; // Exceeds 1000 characters
        this.parkingForm.get('oneTimeBookingsInstructions')?.setErrors(null); // Clear 'required' error if within length limit
        this.textLength[dataKey] = content.length-1;
      } 
      else {
        // Valid content (not empty and within character limit)
        this.textLength[dataKey] = content.length-1; // Store actual length
        this.parkingForm.get('oneTimeBookingsInstructions')?.setErrors(null); // Remove any previous errors
      }
    }else {
      this.textLength[dataKey] = 0;
      this.parkingForm.get('oneTimeBookingsInstructions')?.setErrors({ required: true }); // Clear 'required' error if within length limit

    }    
    this.parkingForm.get('oneTimeBookingsInstructions').setValue(quill.root.innerHTML);
  }

  recurringLimitText(_event: any, editor: Editor, dataKey: string) {
    const quill = editor.getQuill(); // Get Quill editor instance
    const content = quill.getText(); // Get plain text (ignoring HTML tags)
    const contents = quill.getContents();
    const ops = contents.ops;

    let index = 0;

    ops.forEach(op => {
      if (op.insert && op.insert.image) {
        quill.deleteText(index, 1); // delete image
      } else if (typeof op.insert === 'string') {
        index += op.insert.length; // count text length to keep index updated
      } else {
        index += 1; // account for other inserts
      }
    });
    // Reset all errors
    this.recurringEditorTextLimitError = false;
    this.recurringEditorSpaceError = false;

    if( content.length > 1) {
      const trimContent = content.trim();
      if (trimContent.length === 0) {
        this.recurringEditorSpaceError = true; // Content is empty or only spaces
        this.textLength[dataKey] = content.length - 1; // Prevent negative value
        this.parkingForm.get('recurringBookingsInstruction')?.setErrors({ required: true }); // Set 'required' error
      } 
      // Check if the content exceeds 1000 characters
      else if (content.length > 1001) {
        this.recurringEditorTextLimitError = true; // Exceeds 1000 characters
        this.parkingForm.get('recurringBookingsInstruction')?.setErrors(null); // Clear 'required' error if within length limit
        this.textLength[dataKey] = content.length-1;
      } 
      else {
        // Valid content (not empty and within character limit)
        this.textLength[dataKey] = content.length-1; // Store actual length
        this.parkingForm.get('recurringBookingsInstruction')?.setErrors(null); // Remove any previous errors
      }
    }else {
      this.textLength[dataKey] = 0;
      this.parkingForm.get('recurringBookingsInstruction')?.setErrors({ required: true }); // Clear 'required' error if within length limit

    }
    // Check if the content is empty or only spaces
    
  }

  selectTruckType() {
    const selectedTruckData: any[] = (
      this.parkingForm.get('truckTypeArray') as FormArray
    ).value;

    if (selectedTruckData.length > 0) {
      this.truckTypes.map((truck: any) => {
        let isDisabled = selectedTruckData.some((option: any) =>
          option.truckType.includes(truck.id)
        );
        truck.disabled = isDisabled;
      });
    } else {
      this.truckTypes.map((truck: any) => {
        truck.disabled = false;
      });
    }
    this.noOptionsAvailable = this.truckTypes.every(
      (truck: any) => truck.disabled
    );
    this.buttonDisabled = false;
  }

  addFacilityId(id: string) {
    const index = this.parkingLotFacility.indexOf(id);

    if (index !== -1) {
      // ID is in the array, so remove it
      this.parkingLotFacility.splice(index, 1);
    } else {
      // ID is not in the array, so add it
      this.parkingLotFacility.push(id);
    }
  }

  onFileSelected(event: Event): void {
    const input = event.target as HTMLInputElement;
    if (input.files && input.files.length > 0) {
      const file = input.files[0];
      if (!this.isValidFileType(file)) {
        this.toastService.showToastMessage('error', 'Error', 'Only PDF and DOCX files are allowed.');
        return;
      }
      if (file.size > 5 * 1024 * 1024) { // Check if file size is more than 5 MB
        this.toastService.showToastMessage('error', 'Error', 'File size should not exceed 5 MB.');
        return;
      }
      this.uploadedFile = 'Parking Location Terms & Conditions'; // Always show this text
      this.formData.append('Images', file); // Append the file to FormData
      this.documentUpload();
    }
  }

  isValidFileType(file: File): boolean {
    const allowedTypes = ['application/pdf', 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'];
    return allowedTypes.includes(file.type);
  }

  removeFile(fileInput: HTMLInputElement): void {
    this.uploadedFile = null;
    this.termsAndConditionFilePath = null;
    this.isFileUploaded = false;
    this.formData.delete('Images');
    this.parkingForm.get('termsAndConditionFilePath')?.setValue(null);
    this.updateRecurringInstructionsValidator();
    // Reset the file input
    fileInput.value = ''; // Reset the file input
  }

  isSpecialRateEnabled(spotIndex: number): boolean {
    const truckType = this.truckTypeArray.at(spotIndex);
    const dailyRate = truckType.get('dailyRate')?.value;
    const monthlyRate = truckType.get('monthlyRate')?.value;
    return !(dailyRate && monthlyRate); 
  }
  
  nextPage(data: FormGroup): void {
    const oneTimeAccessCode = this.parkingForm.get('oneTimeAccessCode')?.value;
    const monthlyTimeAccessCode = this.parkingForm.get('monthlyTimeAccessCode')?.value;

    if (!oneTimeAccessCode && monthlyTimeAccessCode) {
      this.parkingForm.patchValue({ oneTimeAccessCode: monthlyTimeAccessCode });
    } else if (!monthlyTimeAccessCode && oneTimeAccessCode) {
      this.parkingForm.patchValue({ monthlyTimeAccessCode: oneTimeAccessCode });
    } else if (!oneTimeAccessCode && !monthlyTimeAccessCode) {
      this.parkingForm.patchValue({ oneTimeAccessCode: '', monthlyTimeAccessCode: '' });
    }
    if (!this.parkingForm.get('location')?.value) {
      this.toastService.showToastMessage('error', 'Error', "Please enter a valid address or select one from the suggestions.")
    } else {
      if (this.parkingForm.valid && !this.oneTimeEditorSpaceError && !this.oneTimeEditorTextLimitError && !this.recurringEditorSpaceError && !this.recurringEditorTextLimitError) {
        let parkingLotFacilityArray = data.get('parkingLotFacility') as FormArray;
        this.parkingLotFacility.forEach((fac) => {
          parkingLotFacilityArray.value.push(fac);
        });

        let truckData: any[] = [];
        truckData.push(...this.truckTypeArray.value);
        data.get('parkingPhotos')?.patchValue(this.images);
        this.encryptStorage.setItem('truckData', JSON.stringify(truckData));
        this.encryptStorage.setItem('parkingFirstPage', JSON.stringify(data.value));
        this.parkingSlots();
      } else {
        CustomValidator.markFormGroupTouched(this.parkingForm);
        this.toastService.showToastMessage('error', 'Error', 'Fill All Mandatory Fields');
      }
    }
  }

  save(data: FormGroup): void {
    if (this.parkingUpcomingForm.valid) {
      const CreateComingSoonParking: CreateComingSoonParking = {
        name: data.value.parkingName,
        location: data.value.location,
      };

      if (this.roleName === USER_ROLES.SUPER_ADMIN) {
        CreateComingSoonParking.companyId = this.companyId;
      }
      
      this.parkingService
        .CreateComingSoonParking(CreateComingSoonParking)
        .pipe(
          autoUnsubWith(this.destroyRef)
        )
        .subscribe({
          next: () => {
            
            this.openSuccessModal();
          },
          error: (err: HttpErrorResponse) => {
            
            this.toastService.showToastMessage('error', 'Error', err.error.message);
          },
        });
    } else {
      CustomValidator.markFormGroupTouched(this.parkingUpcomingForm);
      this.toastService.showToastMessage('error', 'Error', 'Fill All Mandatory Fields');
    }
  }

  displayComingsoon() {
    this.comingSoonForm = !this.comingSoonForm;
  }

  openMap(
    form: FormGroup,
    addressControlName: string,
    locationControlName: string
  ) {
    this.dialogControlService.openDialog(MapsComponent, {
      width: '70%',
      data: form.get(locationControlName)?.value,
    });
    this.dialogControlService.onClose().subscribe((response: any) => {
      this.patchLocation(
        response,
        form,
        addressControlName,
        locationControlName
      );
    });
  }

  parkingSlots() {
    const rolePath = this.roleName === USER_ROLES.SUPER_ADMIN ? 'super-admin' : 'manager';
    this.router.navigateByUrl(`${rolePath}/parking/slots`);
  }

  uploadImage1(files: any) {
    this.formData.delete('Images');
    const file = files[0];
    const maxSize = 5 * 1024 * 1024;
    const fileExtension = file.name.split('.').pop()?.toLowerCase();
    this.formData.append('Images', file);

    if (!fileExtension || !this.allowedExtensions.includes(fileExtension)) {
      this.toastService.showToastMessage('error', 'Error', Invalid_IMAGE_FORMAT);
      this.isImgError1 = false;
      this.fileUpload.clear();
      return false;
    } else if (file.size > maxSize && (fileExtension || this.allowedExtensions.includes(fileExtension))) {
      this.isImgError1 = true;
      this.fileUpload.clear();
      return false;
    } else {
      this.isImgError1 = false;
    };

    if (file.size < maxSize && (fileExtension || this.allowedExtensions.includes(fileExtension))) {
      this.parkingService.imageUplaod(this.formData).pipe( autoUnsubWith(this.destroyRef))
        .subscribe((response) => {
          if (response) {
            const data = response;
            for (const key in data) {
              if (data.hasOwnProperty(key)) {
                const url = data[key];
                this.imageUrl1 = url;
                this.images.push(url);
                this.btn1 = true;
                
              }
            }
          }

        });
    };

    return true;
  }

  documentUpload() {
    
    this.parkingService.imageUplaod(this.formData)
      .pipe(autoUnsubWith(this.destroyRef))
      .subscribe((response) => {
        if (response) {
          const data = response;
          for (const key in data) {
            if (data.hasOwnProperty(key)) {
              const url = data[key];
              this.parkingForm.get('termsAndConditionFilePath')?.setValue(url);
              this.termsAndConditionFilePath = url;
              this.isFileUploaded = true;
              this.updateRecurringInstructionsValidator();
              
            }
          }
        }
      });
  }

  uploadImage2(event: any) {
    this.formData.delete('Images');
    const file = event.files[0];
    const fileExtension = file.name.split('.').pop()?.toLowerCase();
    const maxSize = 5 * 1024 * 1024;
    this.formData.append('Images', file);

    if (!fileExtension || !this.allowedExtensions.includes(fileExtension)) {
      this.toastService.showToastMessage('error', 'Error', Invalid_IMAGE_FORMAT);
      this.isImgError2 = false;
      this.fileUpload1.clear();
      return false;
    } else if (file.size > maxSize && (fileExtension || this.allowedExtensions.includes(fileExtension))) {
      this.isImgError2 = true;
      this.fileUpload1.clear();
      return false;
    } else {
      this.isImgError2 = false;
    };

    if (file.size < maxSize && (fileExtension || this.allowedExtensions.includes(fileExtension))) {
      
      this.parkingService
        .imageUplaod(this.formData)
        .pipe(autoUnsubWith(this.destroyRef))
        .subscribe((response) => {
          if (response) {
            const data = response;
            for (const key in data) {
              if (data.hasOwnProperty(key)) {
                const url = data[key];
                this.imageUrl2 = url;
                this.images.push(url);
                this.btn2 = true;
                
              }
            }
          }

        });
    }
    return true;
  };

  uploadImage3(event: any) {
    this.formData.delete('Images');
    const file = event.files[0];
    const fileExtension = file.name.split('.').pop()?.toLowerCase();
    const maxSize = 5 * 1024 * 1024;
    this.formData.append('Images', file);

    if (!fileExtension || !this.allowedExtensions.includes(fileExtension)) {
      this.toastService.showToastMessage('error', 'Error', Invalid_IMAGE_FORMAT);
      this.isImgError3 = false;
      this.fileUpload2.clear();
      return false;
    } else if (file.size > maxSize && (fileExtension || this.allowedExtensions.includes(fileExtension))) {
      this.isImgError3 = true;
      this.fileUpload2.clear();
      return false;
    } else {
      this.isImgError3 = false;
    };
    if (file.size < maxSize && (fileExtension || this.allowedExtensions.includes(fileExtension))) {
      
      this.parkingService
        .imageUplaod(this.formData)
        .pipe(autoUnsubWith(this.destroyRef))
        .subscribe((response) => {
          if (response) {
            const data = response;
            for (const key in data) {
              if (data.hasOwnProperty(key)) {
                const url = data[key];
                this.imageUrl3 = url;

                this.images.push(url);
                this.btn3 = true;
                
              }
            }
          }

        });
    }
    return true;
  }

  fileSizeValidator(maxSize: number) {
    return (control: AbstractControl) => {
      if (control.value) {
        const file = control.value as File; // Cast control.value to File
        if (file.size > maxSize * 1024 * 1024) {
          // Convert maxSize to bytes
          return {
            fileSizeExceedsLimit: true,
          };
        }
      }
      return null;
    };
  }
  del1(event: string) {
    // Find the index of the URL in the array
    const index = this.images.indexOf(event);

    // Check if the URL is in the array
    if (index !== -1) {
      // Remove the URL from the array
      this.images.splice(index, 1);
      this.formData.delete('Images');
      this.isImgError1 = false;
      this.imageUrl1 = '';
      this.btn1 = false;
      this.fileUpload.clear();
    }

    // Verify that the URL has been removed
  }
  del2(event: string) {
    const index = this.images.indexOf(event);

    if (index !== -1) {
      this.images.splice(index, 1);
      this.imageUrl2 = '';
      this.btn2 = false;
      this.formData.delete('Images');
      this.fileUpload1.clear();
    }

  }
  del3(event: string) {
    const index = this.images.indexOf(event);

    if (index !== -1) {
      this.images.splice(index, 1);
      this.imageUrl3 = '';
      this.btn3 = false;
      this.formData.delete('Images');
      this.fileUpload2.clear();
    }

    // Verify that the URL has been removed
  }
  showDialog(imageLink: string): void {
    this.imagePreview = true;
    this.imageLinkForPreview = imageLink;
    this.visible = true;
  }
  onDialogHide(): void {
    this.visible = false;
  }

  searchAutoComplete(location: any, formType: string) {
    if (formType === 'parking') {
      this.patchLocation(location, this.parkingForm, 'locAddress', 'location');
    } else if (formType === 'parkingUpcoming') {
      this.patchLocation(
        location,
        this.parkingUpcomingForm,
        'parkingLocation',
        'location'
      );
    }
  }

  patchLocation(
    location: any,
    form: FormGroup,
    addressControlName: string,
    locationControlName: string
  ): void {
    if (location) {
      form.patchValue({
        [addressControlName]: location.address,
        [locationControlName]: location,
      });
    }
  }

  showData(_rowData: any,event) {
    const actionMap = {
      edit: () => this.editSpecialRate(_rowData),
      delete: () => this.deleteSpecialRate(_rowData,event),
    };
  
    const config = [
      {
        label: '',
        icon: '',
      },
      {
        label: 'Edit',
        icon: 'common-icon custom-editicon',
        escape: false,
        command: actionMap.edit,
      },
      {
        label: 'Delete',
        icon: 'common-icon custom-delete',
        command: actionMap.delete,
      },
    ];
  
    this.items = this.commonMenuService.commonShowData(config);
  }
  
  toogleHazardousload() {
    this.disableForm = !this.disableForm;
  }

  onCkEditorReady(_editor: any): boolean {
    const result = true;
    return result;
  }

  onKeyPressAllowTwoDigitAfterPoint(event: KeyboardEvent): void {
    if (!validateInput(event)) {
      event.preventDefault();
    }
  }

  openSuccessModal(): void {
    this.dialogControlService.openDialog(SuccessModalComponent, {
      data: {
        bodyText: MSG_CREATE_PARKING,
      },
    });
  }

  editSpecialRate(record: SpecialRate) {
    const editIndex = this.specialRates.indexOf(record);
    const ref = this.dialogControlService.openDialog(CustomRatesPopupComponent, {
      styleClass: 'custom-rate-main',
      data: {
        SpotTypeId: record.spotTypeId,
        exsistingRecord: record,
        editIndex: editIndex
      }
    });

    this.dialogControlService.onClose().subscribe((result) => {
      if (result && result.specialRate) {
        const { specialRate, editIndex } = result;

        if (editIndex > -1) {
          this.specialRates.splice(editIndex, 1, ...specialRate);
        } else {
          this.specialRates.push(specialRate);
        }

        this.cdr.detectChanges();
      }
    });
  }

  openCustomRates(id: string): void {
    const truckType = this.truckTypeArray.controls.find(
      (control: any) => control.get('spotTypeId')?.value === id
    );  
    const dailyRate = truckType?.get('dailyRate')?.value;
    const monthlyRate = truckType?.get('monthlyRate')?.value;
  
    const ref = this.dialogControlService.openDialog(CustomRatesPopupComponent, {
      styleClass: 'custom-rate-main',
      data: {
        SpotTypeId: id,
        dailyRate:dailyRate,
        monthlyRate:monthlyRate
      }
    });
    this.dialogControlService.onClose().subscribe((result) => {
      if (result.specialRate && Array.isArray(result.specialRate)) {
        for (const record of result.specialRate) {
          this.specialRates.push(record);
        }
        this.cdr.detectChanges();
      }
    });
  }

  getRatesBySpotTypeId(spotTypeId: string): SpecialRate[] {
    return this.specialRates.filter(rate => rate.spotTypeId === spotTypeId);
  }

  deleteSpecialRate(record: SpecialRate,event): void {
    this.confirmationService.confirm({
      target: event.target as EventTarget,
      message: MSG_DELETE_VEHICLE,
      icon: 'pi pi-exclamation-triangle',
      accept: () => {
        const index = this.specialRates.findIndex(
          rate => rate.code === record.code && rate.spotTypeId === record.spotTypeId
        );
        if (index > -1) {
          this.specialRates.splice(index, 1);
          this.cdr.detectChanges();
        }
      }
    });
  }

  preventSpaces(event: KeyboardEvent) {
    CommonFunctions.preventSpaces(event);
  }

  preventFirstSpace(event: KeyboardEvent) {
    CommonFunctions.preventFirstSpaces(event);
  }
}
